import styled from "styled-components";
import theme from "common/theme";

export const ConfigurableChartDemoContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr 300px;
  grid-template-columns: 300px 1fr;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  overflow: hidden;
  z-index: 1000;
  background-color: white;

  .full {
    grid-column-start: span 3;
  }
  > h2 {
    margin: 0;
    padding:  1em;
    background: ${theme.colors.jbtBlue};
    color: white;
  }
  > .col-l {
    grid-column: 1;
    grid-row: 2;
    display: grid;
  }

  > .col-r {
    grid-column: 2;
    grid-row: 2;
    display: grid;
    

    .padding {
      display: grid;
      position: relative;
    }
  }

  .padding { padding: 1em;}

  .data-area {
    display: grid;
    grid-column: 1 / span 2;
    grid-row: 3;
    grid-template-columns: 200px 1fr;
  }

  .data-settings {
  }
`